(function () {
  'use strict';

  function selectMonatlich() {
    var inputs = document.querySelectorAll('input[data-option-name="lieferintervall"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.toLowerCase().includes('monatlich')) {
        if (!inputs[i].checked) {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
      }
    }
  }

  function setOnetime(isOnetime) {
    if (isOnetime) {
      document.body.classList.add('nooq--onetime');
      selectMonatlich();
    } else {
      document.body.classList.remove('nooq--onetime');
    }
  }

  function init() {
    // Appstle feuert change auf selling_plan:
    //   value="" → Einmalkauf, value=<id> → Abo
    // e.target direkt nutzen (querySelector würde ggf. falschen Input finden)
    document.addEventListener('change', function (e) {
      if (e.target.name === 'selling_plan') {
        setOnetime(e.target.value === '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
